import { BULANDI_2026_LINKS } from "./bulandi2026Data";
import { omertaMeta } from "./omertaData";
import { rifleShootingMeta } from "./rifleShootingData";

/**
 * Static fallback for the homepage Events section, shown only when the smym-app API
 * (`GET /api/public/events`) is unreachable. Live listings and registrations are managed
 * in smym-app Admin → Events. This list is the offline fallback. Once the API
 * returns any past events, those replace this list. Bulandi 2026 is members-only
 * on the API, so that entry (detailsPath) is still merged in. Same name and date
 * collapse to one card.
 */
export const upcomingEvents = [];
export const pastEvents = [
  {
    name: rifleShootingMeta.name,
    date: rifleShootingMeta.date,
    description: [
      `${rifleShootingMeta.tagline}.`,
      `Open to ${rifleShootingMeta.ageNote}.`,
    ].join(" "),
    specialMention: rifleShootingMeta.sponsors.join(" & "),
  },
  {
    name: omertaMeta.name,
    date: "2026-09-26",
    attendees: 61,
    description:
      "OMERTÀ - The Code of Silence brought together 60+ young members for an immersive Mafia Game Night of strategy, conversations and fun. With 53 registrations in just 6 days, the response reflected the youth's desire to connect through fresh and engaging experiences. A simple game became a platform for communication, networking and fellowship, bringing several new faces together. With no elaborate frills, the experience and people remained at the heart of the evening. OMERTÀ marked a fresh approach for SMYM Chennai, modern in format, rooted in community values and focused on bringing the youth closer.",
    coordinator: "Mahima Rathi & Tapas Bhattad",
    specialMention: "Namrata Jain Bhattad",
  },
  {
    name: "Bulandi 2026",
    date: "2026-07-26",
    description:
      "Kanta J Narayan Rathi Bulandi 2026 — SMYM's flagship cultural festival across four Sundays in July, with competitions for Juniors, Intermediates and Seniors, family game shows, and a full workshops track. Registrations are now closed; the event page stays up as an archive.",
    detailsPath: BULANDI_2026_LINKS.home,
    detailsLabel: "Explore Bulandi 2026",
  },
  {
    name: "AGM",
    date: "2026-05-03",
    attendees: 51,
    description:
      "The Annual General Meeting (AGM) of Shree Maheshwari Yuva Mandal, Chennai was held at Rajasthan Association (RAJAT Hall), Sindur Plaza, Chennai, in the presence of members, advisors, and senior dignitaries. The evening reflected upon a year of meaningful engagement, during which SMYM successfully conducted 15 events across diverse themes within a span of less than 10 months. The Secretary's and Treasurer's reports were presented and approved, followed by discussions on future direction, participation, and community engagement. The evening also entailed President accolades Team SMYM, Committee members on commendable job done through the year. The evening concluded with fellowship and dinner, reinforcing the spirit of warmth, collaboration, and belonging within the SMYM community.",
    coordinator: "Hemanth Bhattad",
  },
  {
    name: "Temple Run 2.0",
    date: "2026-04-04",
    attendees: 38,
    description:
      "Temple Run 2.0 to Arunachala Pradakshina started with a visit to Melmaruvathur Temple followed by Bhajan Jamming at Nomad Café. The highlight of this trip was 14kms pradakshina around Girivalam covering Ashtalingam on foot at 1am followed by Arunachaleshwar darshan at 5am.",
    coordinator: "Ankit Rathi",
    specialMention: "Shri Ramratan Chandak",
  },
  {
    name: "Quietly Powerful",
    date: "2026-03-08",
    attendees: 80,
    description:
      "The Women's Day celebration Quietly Powerful at Shenoy Nagar turned into a warm and meaningful evening, beginning with a vibrant Resin Art workshop by Smt. Kriti Suda, where nearly 40 ladies explored their creative side. The highlight was the felicitation of Smt. Vimala Damani, a dynamic and visionary personality. The evening also featured an insightful awareness session in collaboration with LifeCell, where Smt. Srirekha shared perspectives on Stem Cell Science & Future Health Preparedness.",
    coordinator: "Alka Rathi & Priyanka Mantri",
    specialMention: "Smt. Vimala Damani",
  },
  {
    name: "Turtle Trail",
    date: "2026-02-21",
    attendees: 30,
    description:
      "Along the Turtle Trail was a guided night walk along Chennai's shoreline in association with the Students' Sea Turtle Conservation Network. Over 8 kilometres of sand, participants experienced the physical challenge of a midnight trail, witnessed the realities of marine life, and discovered a live turtle nest, a powerful reminder of resilience, life, and balance.",
    coordinator: "Vikramaditya Bisani & Atul Maheswari",
  },
  {
    name: "Neel aur Neer",
    date: "2026-02-15",
    attendees: 30,
    description:
      "The event was a Mahashivratri morning experience designed to challenge the mind and connect inward. Participants began with a 3.3 km pre-dawn jog, followed by an inner circle discussion and a guided ice bath. Rooted in resilience and reflection, the experience blended physical discipline with mental stillness.",
    coordinator: "Yash Malpani",
  },
  {
    name: "Temple Run",
    date: "2026-01-25",
    attendees: 61,
    description:
      "A unique heritage walk visiting 3 temples early morning for Darshan and knowing about the history of the temples, their significance, about the architecture. Temples covered in edition 1 were Sri Kapaleeswarar Temple, Sri Parthasarathy Temple & RK Math.",
    coordinator: "Chirag Jhawar & Abhinandan Chandak",
  },
  {
    name: "Shree Maheshwari Annakut Mahotsav",
    date: "2025-10-26",
    attendees: "800+",
    description:
      "SMYM along with Shree Maheshwari Satsang Samiti, Shree Maheshwari Mahila Mandal, Chennai organised Annakut Mahotsav for the entire Vaishnav Samaj in Chennai.",
    coordinator: "Kriti Suda & Nikhil Mohta",
    specialMention: "Event Chairperson Shri Narayandas J Rathi",
  },
  {
    name: "Utkarsh",
    date: "2025-10-05",
    attendees: "250+",
    description:
      "SMYM's Diwali Milan event which saw felicitation of SMYM's Past President & Secretary and recognition of NextGen Superstar participants & winners. The latter also presented their Finale acts on stage and enthralled the audience.",
    coordinator: "Ankit Rathi & Ketan Bisani",
    specialMention: "Event Sponsor Shri Praveen Maheshwari (Bisani)",
  },
  {
    name: "Mission ISRO",
    date: "2025-09-25",
    attendees: 45,
    description:
      "A flagship event organised by SMYM for youth and children, visiting NRSC Hyderabad with an objective to Space as Career opportunity.",
    coordinator: "Atul Maheshwari",
    specialMention: "Shri Harish Sarda",
  },
  {
    name: "The Evolve Fest",
    date: "2025-09-18",
    attendees: 25,
    description:
      "A 3 day Spiritual Retreat organised by Shri Bramrishi Ashram, Tirupati",
    coordinator: "Kushal Maheswari",
  },
  {
    name: "Cyclothon in Association with Rajat",
    date: "2025-09-14",
    attendees: 110,
    description: "Cycling event – 10kms, 25kms, 50kms",
    coordinator: "Kushal Maheswari",
  },
  {
    name: "Hasyam",
    date: "2025-08-31",
    attendees: 52,
    description:
      "Associated Partner for Hasyam, a humor poetry symposium held at Chinmaya Heritage Center, Chetpet",
    coordinator: "Girish Singh Mohta",
  },
  {
    name: "Nextgen Superstar, Hyderabad",
    date: "2025-08-22",
    attendees: 25,
    description:
      "SMYM's selected team represented TKPPMYS at the All India Culturals, held at Hyderabad. SMYM was instrumental in organising, training and mentoring the participants along with their enthusiastic parents. We garnered 14 finalists from a team of 25 participants, and got podium finish in 7 events at the Nationals.",
  },
  {
    name: "Movie with SMYM - War 2",
    date: "2025-08-15",
    attendees: 50,
    description: "War 2 movie screening for SMYM members",
    coordinator: "Nikhil Mohta & Hemanth Bhattad",
  },
  {
    name: "Nextgen Superstar – Tayyari Jeet Ki",
    date: "2025-06-29",
    attendees: 75,
    description:
      "SMYM hosted TKPPMYS Prelims at Agarwal Vidyalaya, Chennai with an objective to select team representing TKPPMYS at All India Culturals, NextGen Superstar.",
    specialMention: "Sponsor Shri Kundanlal Jethmal Anand Chandak (Lathiwale)",
  },
  {
    name: "Shivoham - Culturals",
    date: "2025-06-15",
    attendees: "1000+",
    description:
      "Mansarovar - Sacred Journey to Mt. Kailash themed cultural event conceptualized and presented by SMYM at Shree Maheshwari Sabha's Mahesh Navmi event, Shivoham.",
  },
];
